<ng-container *ngIf="previewDataFields">
  <div class="groups" id="parentdiv">
    <div class="mb-3" *ngIf="showFormModel">
      <irembogov-service-request-header-togger-widget
        [options]="headerOptions"
        [selectedOption]="selectedOption"
        (selectOption)="
          onHeaderOptionChange($event)
        "></irembogov-service-request-header-togger-widget>
    </div>
    <div
      *ngIf="
        selectedOption === EServiceChangeRequestToggleHeaders.PREVIEW;
        else formModel
      ">
      <form
        [formGroup]="form"
        class="preview-service-change-request-json-formdata-widget"
        (ngSubmit)="onTriggerValidations()">
        <fieldset [disabled]="viewOnlyMode">
          <formly-form
            [form]="form"
            [options]="options"
            [model]="model"
            [fields]="previewDataFields"
            cdkDropListGroup></formly-form>
        </fieldset>

        <div
          class="border-dashed border-dashed-primary p-5 text-center pointer-cursor"
          *ngIf="!reviewModeEnabled && !viewOnlyMode"
          (keydown)="addNewSectionToFields()"
          (click)="addNewSectionToFields()">
          <h6><i class="fa-solid fa-plus me-1"></i>New Section</h6>
        </div>
        <div class="w-100 my-4" *ngIf="!viewOnlyMode">
          <button class="btn btn-primary w-100" type="submit">
            Trigger validations
          </button>
        </div>
      </form>
    </div>
    <ng-template #formModel>
      <div class="json-container">
        <irembogov-json-viewer
          [data]="getTransformedModel()"></irembogov-json-viewer>
      </div>
    </ng-template>
  </div>
</ng-container>
